import React from "react";
import { CookieBannerMessageContext } from "../context/cookie-banner-message-context";
import { CookieBannerMessage } from "../elements/cookie-banner-message";
export var useCookieBannerMessage = function () {
  return React.useContext(CookieBannerMessageContext) || CookieBannerMessage;
};